angular.module("vgresiduos").directive("disposalDestinator", function () {
	return {
		scope: true,
		controller: "DisposalDestinatorCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalDestinator/disposalDestinator_template.html"
	};
});
